<template>
  <div class="main-container">
    <!-- <div class="container">
      <input type="radio" id="tab1" name="tab" checked />
      <label for="tab1"><em class="fa fa-code"></em>About</label>
      <input type="radio" id="tab2" name="tab" />
      <label for="tab2"><em class="fa fa-history"></em>Projects</label>
      <hr />
      <br />
      <div class="line"></div>
      <div class="content-container">
        <div class="content" id="c1">
          <img
            src="../assets/Consultancy_logo.png"
            style="width: 170px; display: inline-block; vertical-align: top;"
            alt="No image"
          />
          <h2
            class="heading"
            style="
              display: inline-block;
              vertical-align: top;
              line-height: 4rem;
            "
          ></h2>

          <p class="about-content">
            Akaar Consultants is one of the renowned consultancy firm delivering
            its top-drawer services in the field of Structural and Architectural
            designing along with project management consultancy from more than
            25 years now. The goal of the firm has always been to provide the
            customers with cost effective and aesthetic, but at the same time
            safe and reliable structures. As consultants, we have successfully
            handled more than 100 projects till date. We have been proudly
            consulting for the designs of various types of structures like –
            Residential bungalows, Residential apartments, Commercial complexes,
            Industrial Buildings, Farmhouses, Restaurants, Resorts, Hospitals,
            Showrooms and many more of such kind. Our projects have been spread
            all across the regions of Kolhapur, Sangli, Satara, Panchgani,
            Belgaum, Gadhinglaj and Konkan. With a perfect blend of analytical
            abilities, in depth knowledge &amp; years of practical experience,
            Akaar Consultants have been delivering services that exceed client
            expectations. Our premium services will not only help you to meet
            your design expectations, but also fit within your time and cost
            frame.
          </p>
        </div>

        <div class="content" id="c2">
          <div class="row">
            <div class="column">
              <div class="card">
                <h3>Residential Bunglow Kankavali</h3>
                <div class="container1">
                  <img
                    src="../assets/consultancy/Residencial Bunaglow- Kankavali.jpg"
                    style="max-width: 100%; cursor: pointer;"
                    @click="expand"
                    class="modal-hover-opacity"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="card">
                <h3>Commercial complex, Gandhinglaj</h3>
                <div class="container1">
                  <img
                    src="../assets/consultancy/Commercial Complex - Gadhinglaj-min.jpg"
                    style="
                      width: 100%;
                      height: 162px;
                      cursor: pointer;
                      object-fit: cover;
                    "
                    @click="expand"
                    class="modal-hover-opacity"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="card">
                <h3>Farmhouse, Gadhinglaj</h3>
                <br />
                <div class="container1">
                  <img
                    src="../assets/consultancy/Farmhouse - Gahinglaj.jpg"
                    style="max-width: 100%; cursor: pointer;"
                    @click="expand"
                    class="modal-hover-opacity"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="card">
                <h3>Industrial Building, Five star MIDC</h3>
                <div class="container1">
                  <img
                    src="../assets/consultancy/Industrial Building - Five star MIDC.jpg"
                    style="max-width: 100%; cursor: pointer;"
                    @click="expand"
                    class="modal-hover-opacity"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="column">
              <div class="card">
                <h3>Milk collection Center, Gadhinglaj</h3>
                <div class="container1">
                  <img
                    src="../assets/consultancy/Milk collection Center - Gadhinglaj.jpg"
                    style="max-width: 100%; cursor: pointer;"
                    @click="expand"
                    class="modal-hover-opacity"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="card">
                <h3>Residential bungalow, Bhadgaon</h3>
                <div class="container1">
                  <img
                    src="../assets/consultancy/residential bungalow - Bhadgaon.jpg"
                    style="
                      width: 100%;
                      height: 162px;
                      cursor: pointer;
                      object-fit: cover;
                    "
                    @click="expand"
                    class="modal-hover-opacity"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="card">
                <h3>Residential bungalow, Gadhinglaj</h3>
                <div class="container1">
                  <img
                    src="../assets/consultancy/residential bungalow - Gadhinglaj copy.jpg"
                    style="max-width: 100%; cursor: pointer;"
                    @click="expand"
                    class="modal-hover-opacity"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="card">
                <h3>Residential bungalow, Gadhinglaj</h3>
                <div class="container1">
                  <img
                    src="../assets/consultancy/Residential bungalow - Gadhinglaj.jpg"
                    style="max-width: 100%; cursor: pointer;"
                    @click="expand"
                    class="modal-hover-opacity"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="column">
              <div class="card">
                <h3>Talim Building, Kolhapur</h3>
                <br />
                <div class="container1">
                  <img
                    src="../assets/consultancy/Talim Building - Kolhapur.jpg"
                    style="max-width: 100%; cursor: pointer;"
                    @click="expand"
                    class="modal-hover-opacity"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="card">
                <h3>Residential bungalow, Kolhapur</h3>
                <div class="container1">
                  <img
                    src="../assets/consultancy/Residential bungalow - Kolhapur.jpg"
                    style="
                      width: 100%;
                      height: 162px;
                      cursor: pointer;
                      object-fit: cover;
                    "
                    @click="expand"
                    class="modal-hover-opacity"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="card">
                <h3>Residential bungalow, Gadhinglaj</h3>
                <div class="container1">
                  <img
                    src="../assets/consultancy/Residential bungalow -Gadhinglaj.jpg"
                    style="max-width: 100%; cursor: pointer;"
                    @click="expand"
                    class="modal-hover-opacity"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="card">
                <h3>Row bungalow, Kolhapur</h3>
                <br />
                <div class="container1">
                  <img
                    src="../assets/consultancy/Row bungalow - Kolhapur.jpg"
                    style="max-width: 100%; cursor: pointer;"
                    @click="expand"
                    class="modal-hover-opacity"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="column">
              <div class="card">
                <h3>Residential bungalow, Kolhapur</h3>
                <div class="container1">
                  <img
                    src="../assets/consultancy/Residential bungalow- Kolhapur.jpg"
                    style="max-width: 100%; cursor: pointer;"
                    @click="expand"
                    class="modal-hover-opacity"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="card">
                <h3>Residential Commercial, Kankavli</h3>
                <div class="container1">
                  <img
                    src="../assets/consultancy/Residential_Commercial - Kankavli.jpg"
                    style="
                      width: 100%;
                      height: 162px;
                      cursor: pointer;
                      object-fit: cover;
                    "
                    @click="expand"
                    class="modal-hover-opacity"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="card">
                <h3>Resort, Panchgani</h3>
                <br />
                <div class="container1">
                  <img
                    src="../assets/consultancy/Resort - Panchgani-min.jpg"
                    style="max-width: 100%; cursor: pointer;"
                    @click="expand"
                    class="modal-hover-opacity"
                  />
                </div>
              </div>
            </div>
            <div class="column"></div>
          </div>
          <div
            id="modal01"
            class="modal"
            style="display: block;"
            onclick="this.style.display='none'"
          >
            <span class="close">&times;&nbsp;&nbsp;&nbsp;&nbsp;</span>ssss
            <div class="modal-content">
              <img id="img01" style="max-width: 100%;" />
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="tabs">
      <div id="about" class="active" @click="selectTab('about')">About</div>
      <div id="projects" @click="selectTab('projects')">Projects</div>
    </div>
    <div class="tab-content">
      <div id="about-content" class="about active">
        <img
          src="../assets/Consultancy_logo.png"
          style="width: 170px; display: inline-block; vertical-align: top;"
          alt="No image"
        />
        <h2
          class="heading"
          style="
              display: inline-block;
              vertical-align: top;
              line-height: 4rem;
            "
        ></h2>

        <p class="about-content">
          Akaar Consultants is one of the renowned consultancy firm delivering
          its top-drawer services in the field of Structural and Architectural
          designing along with project management consultancy from more than 25
          years now. The goal of the firm has always been to provide the
          customers with cost effective and aesthetic, but at the same time safe
          and reliable structures. As consultants, we have successfully handled
          more than 100 projects till date. We have been proudly consulting for
          the designs of various types of structures like – Residential
          bungalows, Residential apartments, Commercial complexes, Industrial
          Buildings, Farmhouses, Restaurants, Resorts, Hospitals, Showrooms and
          many more of such kind. Our projects have been spread all across the
          regions of Kolhapur, Sangli, Satara, Panchgani, Belgaum, Gadhinglaj
          and Konkan. With a perfect blend of analytical abilities, in depth
          knowledge &amp; years of practical experience, Akaar Consultants have
          been delivering services that exceed client expectations. Our premium
          services will not only help you to meet your design expectations, but
          also fit within your time and cost frame.
        </p>
      </div>
      <div id="projects-content" class="projects">
        <div class="row">
          <div class="column">
            <div class="card">
              <h3>Residential Bunglow Kankavali</h3>
              <div class="container1">
                <img
                  src="../assets/consultancy/Residencial Bunaglow- Kankavali.jpg"
                  style="max-width: 100%; cursor: pointer;"
                  @click="expand"
                  class="modal-hover-opacity"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="card">
              <h3>Commercial complex, Gandhinglaj</h3>
              <div class="container1">
                <img
                  src="../assets/consultancy/Commercial Complex - Gadhinglaj-min.jpg"
                  style="
                      width: 100%;
                      height: 162px;
                      cursor: pointer;
                      object-fit: cover;
                    "
                  @click="expand"
                  class="modal-hover-opacity"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="card">
              <h3>Farmhouse, Gadhinglaj</h3>
              <br />
              <div class="container1">
                <img
                  src="../assets/consultancy/Farmhouse - Gahinglaj.jpg"
                  style="max-width: 100%; cursor: pointer;"
                  @click="expand"
                  class="modal-hover-opacity"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="card">
              <h3>Industrial Building, Five star MIDC</h3>
              <div class="container1">
                <img
                  src="../assets/consultancy/Industrial Building - Five star MIDC.jpg"
                  style="max-width: 100%; cursor: pointer;"
                  @click="expand"
                  class="modal-hover-opacity"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <div class="card">
              <h3>Milk collection Center, Gadhinglaj</h3>
              <div class="container1">
                <img
                  src="../assets/consultancy/Milk collection Center - Gadhinglaj.jpg"
                  style="max-width: 100%; cursor: pointer;"
                  @click="expand"
                  class="modal-hover-opacity"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="card">
              <h3>Residential bungalow, Bhadgaon</h3>
              <div class="container1">
                <img
                  src="../assets/consultancy/residential bungalow - Bhadgaon.jpg"
                  style="
                      width: 100%;
                      height: 162px;
                      cursor: pointer;
                      object-fit: cover;
                    "
                  @click="expand"
                  class="modal-hover-opacity"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="card">
              <h3>Residential bungalow, Gadhinglaj</h3>
              <div class="container1">
                <img
                  src="../assets/consultancy/residential bungalow - Gadhinglaj copy.jpg"
                  style="max-width: 100%; cursor: pointer;"
                  @click="expand"
                  class="modal-hover-opacity"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="card">
              <h3>Residential bungalow, Gadhinglaj</h3>
              <div class="container1">
                <img
                  src="../assets/consultancy/Residential bungalow - Gadhinglaj.jpg"
                  style="max-width: 100%; cursor: pointer;"
                  @click="expand"
                  class="modal-hover-opacity"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <div class="card">
              <h3>Talim Building, Kolhapur</h3>
              <br />
              <div class="container1">
                <img
                  src="../assets/consultancy/Talim Building - Kolhapur.jpg"
                  style="max-width: 100%; cursor: pointer;"
                  @click="expand"
                  class="modal-hover-opacity"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="card">
              <h3>Residential bungalow, Kolhapur</h3>
              <div class="container1">
                <img
                  src="../assets/consultancy/Residential bungalow - Kolhapur.jpg"
                  style="
                      width: 100%;
                      height: 162px;
                      cursor: pointer;
                      object-fit: cover;
                    "
                  @click="expand"
                  class="modal-hover-opacity"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="card">
              <h3>Residential bungalow, Gadhinglaj</h3>
              <div class="container1">
                <img
                  src="../assets/consultancy/Residential bungalow -Gadhinglaj.jpg"
                  style="max-width: 100%; cursor: pointer;"
                  @click="expand"
                  class="modal-hover-opacity"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="card">
              <h3>Row bungalow, Kolhapur</h3>
              <br />
              <div class="container1">
                <img
                  src="../assets/consultancy/Row bungalow - Kolhapur.jpg"
                  style="max-width: 100%; cursor: pointer;"
                  @click="expand"
                  class="modal-hover-opacity"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <div class="card">
              <h3>Residential bungalow, Kolhapur</h3>
              <div class="container1">
                <img
                  src="../assets/consultancy/Residential bungalow- Kolhapur.jpg"
                  style="max-width: 100%; cursor: pointer;"
                  @click="expand"
                  class="modal-hover-opacity"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="card">
              <h3>Residential Commercial, Kankavli</h3>
              <div class="container1">
                <img
                  src="../assets/consultancy/Residential_Commercial - Kankavli.jpg"
                  style="
                      width: 100%;
                      height: 162px;
                      cursor: pointer;
                      object-fit: cover;
                    "
                  @click="expand"
                  class="modal-hover-opacity"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="card">
              <h3>Resort, Panchgani</h3>
              <br />
              <div class="container1">
                <img
                  src="../assets/consultancy/Resort - Panchgani-min.jpg"
                  style="max-width: 100%; cursor: pointer;"
                  @click="expand"
                  class="modal-hover-opacity"
                />
              </div>
            </div>
          </div>
          <div class="column"></div>
        </div>
        <div
          id="modal01"
          class="modal"
          
          onclick="this.style.display='none'"
        >
          <span class="close">&times;&nbsp;&nbsp;&nbsp;&nbsp;</span>ssss
          <div class="modal-content">
            <img id="img01" style="max-width: 100%;" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    expand: function(event) {
      // console.log(event.target);
      document.getElementById("img01").src = event.target.src;
      document.getElementById("modal01").style.display = "block";
    },
    selectTab: function(tabName) {
      // console.log(tabName);
      var tabs = document.querySelectorAll(".tabs > div");
      var tabContents = document.querySelectorAll(".tab-content > div");

      tabs.forEach((tab) => {
        if (tab.id !== tabName) {
          tab.classList.remove("active");
        } else {
          tab.classList.add("active");
        }
        // console.log(tab.id);
      });

      tabContents.forEach((content) => {
        if (content.id !== tabName + "-content") {
          content.classList.remove("active");
        } else {
          content.classList.add("active");
        }
      });
      // console.log(tabs);
    },
  },
  mounted: function() {
    // var content = document.querySelector(
    //   "body .container input#tab1:checked ~ .content-container #c2"
    // );
    // var parent = document.querySelector(".main-container");
    // parent.style.height = content.offsetHeight + 300 + "px";
  },
};
</script>

<style scoped>
/* *{
  background: black;
  border: 1 px solid red;
} */

/* Tab styling */

.tabs {
  display: flex;
}
.tabs > div {
  flex-grow: 1;
  flex-basis: 0;
  text-align: center;
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid black;
  transform: border .4s ease;
  text-transform: uppercase;
  font-weight: bold;
}

.tabs > div.active {
  border-bottom: 4px solid #005570;
  background: rgb(196, 196, 196);
}

.tab-content > .about,
.tab-content > .projects {
  /* background: red; */
  padding: 20px 0;
  display: none;
}

.tab-content > .about.active,
.tab-content > .projects.active {
  display: block;
}

/* tab styling end */
.main-container {
  padding-top: 20vh;
  padding-bottom: 50px;
  /* position: ; */
  padding-left: 10vw;
  padding-right: 10vw;
  position: relative;
}
/* responsive cards */
/* Float four columns side by side */
.column {
  float: left;
  width: 25%;
  padding: 0 10px;
}
.about-content {
  text-indent: 50px;
  line-height: 2rem;
}

/* Remove extra left and right margins, due to padding */
.row {
  /* margin: 0 -5px; */
  margin-bottom: 10px;
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}
.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  padding: 16px;
  text-align: center;
  background-color: #ffffff;
  border-radius: 5px;
  height: 270px;
}
/* responsive cards end */
/* modal */
.modal {
  z-index: 1;
  display: none;
  padding-top: 10px;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.8);
}

.modal-content {
  margin: auto;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.modal-hover-opacity {
  opacity: 1;
  filter: alpha(opacity=100);
  -webkit-backface-visibility: hidden;
}

.modal-hover-opacity:hover {
  opacity: 0.6;
  filter: alpha(opacity=60);
  -webkit-backface-visibility: hidden;
}

.close {
  text-decoration: none;
  float: right;
  font-size: 24px;
  font-weight: bold;
  color: white;
}
.container1 {
  width: inherit;
  display: inline-block;
}
.container1 > img {
  width: 100%;
  height: 162px;
  cursor: pointer;
  object-fit: cover;
}
.modal-content {
  /*
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s; */
}

@-webkit-keyframes zoom {
  from {
    -webkit-transform: scale(0);
  }
  to {
    -webkit-transform: scale(1);
  }
}

@keyframes zoom {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

body .container input {
  display: none;
}

body .container input:checked + label {
  background: #e8e8e8;
}

body .container input#tab1:checked ~ .line {
  left: 0%;
}

body .container input#tab1:checked ~ .content-container #c1 {
  opacity: 1;
}

body .container input#tab2:checked ~ .line {
  left: 50%;
}

body .container input#tab2:checked ~ .content-container #c2 {
  opacity: 1;
}

body .container input#tab3:checked ~ .line {
  left: 50%;
}

body .container input#tab3:checked ~ .content-container #c3 {
  opacity: 1;
}

body .container input#tab4:checked ~ .line {
  left: 75%;
}

body .container input#tab4:checked ~ .content-container #c4 {
  opacity: 1;
}

body .container label {
  display: inline-block;
  font-size: 16px;
  height: 36px;
  line-height: 36px;
  width: 50%;
  text-align: center;
  background: #ffffff;
  color: #555555;
  position: relative;
  -webkit-transition: 0.25s background ease;
  transition: 0.25s background ease;
  cursor: pointer;
}

body .container label::after {
  content: "";
  height: 2px;
  width: 100%;
  position: absolute;
  display: block;
  background: #ccc;
  bottom: 0;
  opacity: 0;
  left: 0;
  -webkit-transition: 0.25s ease;
  transition: 0.25s ease;
}

body .container label:hover::after {
  opacity: 0;
}

body .container .line {
  position: relative;
  height: 2px;
  background: #1e88e5;
  width: 50%;
  top: -25px;
  left: 0;
  -webkit-transition: 0.25s ease;
  transition: 0.25s ease;
}

body .container .content-container {
  background: #ffffff;
  position: relative;
  /*font-size: 16px;*/
}

body .container .content-container .content {
  position: absolute;
  padding: 10px;
  width: 100%;
  top: 0;
  opacity: 0;
  -webkit-transition: 0.25s ease;
  transition: 0.25s ease;
  color: #333;
}

body .container .content-container .content h3 {
  font-weight: 200;
  margin: 10px 0;
}

body .container .content-container .content p {
  margin: 10px 0;
}

body .container .content-container .content p,
body .container .content-container .content i {
  font-size: 16px;
}

/*//////////////*/
@media screen and (max-width: 500px) {
  .main-container {
    padding-top: 13vh;
    /* padding-bottom: 50vh; */
  }
  .column {
    width: 100%;
    display: block;
    margin-bottom: 20px;
  }
  .modal-content {
    width: 100vw;
  }
  .card {
    height: 300px;
  }
}
</style>
